import React from "react";
import tw from "twin.macro";

import LogoImage from "../../images/new-ui-imgs/white-logo.png";
const Container = tw.div`relative bg-primary-500 text-gray-700 px-8 py-10`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;

const LogoContainer = tw.div`flex items-center justify-center flex-row mx-auto`;
const LogoImg = tw.img`w-full`;
const Divider = tw.div`my-8 border-b-2 border-gray-300 w-full`;

const CopywrightNotice = tw.p`text-center text-sm sm:text-base mt-8 md:mt-0 font-medium text-gray-lightest`;

export default () => {
  return (
    <Container>
      <Content>
        <LogoContainer style={{ maxWidth: 280 }}>
          <LogoImg alt="MAI Motion" src={LogoImage} />
        </LogoContainer>
        <Divider />
        <CopywrightNotice>&copy; 2025 Mai Motion. All Rights Reserved.</CopywrightNotice>
      </Content>
    </Container>
  );
};
